





















































































































import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';
import { Toast, ImagePreview } from 'vant';
Vue.use(ImagePreview);
@Component
export default class Rules extends Vue {
  data: any = {};
  showOnlineTip = true;
  imgs: any = [
    require('../assets/two.png'),
    require('../assets/two1.png'),
    require('../assets/one.png'),
  ];
  content: any = {};
  async created() {
    const res: any = await getRule();
    this.data = res.data;
  }
  async mounted() {
    setTimeout(() => {
      this.showOnlineTip = false;
    }, 5000);
    if (this.$route.query.scroll) {
      this.$nextTick(() => {
        document.documentElement.scrollTop = (this.$refs.img as any).offsetTop;
        document.body.scrollTop = (this.$refs.img as any).offsetTop;
      });
    }
    const res = await getRule();
    if (res.data) {
      this.content = res.data;
    }
  }
  copy() {
    Toast.success('复制成功');
  }
  img(index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: this.imgs, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
